import React from "react";
import { Icomoon } from "src/assets/icons";
import { STRINGS } from "src/shared/constants";

//styles
import S from "./style.module.scss";

const ActWidget = ({ data = {} }) => {
  if (!!!Object.keys(data)?.length) return null;

  return (
    <div className={S.container}>
      <div className={S.header}>
        <div className={S.headerImage}>
          <Icomoon className={S.headerImageIcon} icon={"lungs"} />
        </div>
        <div className={S.headerDesc}>
          <p className={S.headerDescTitle}>{STRINGS.ACT}</p>
          {/* <p
            className={S.headerDescText}
          >{`Age: Over ${data.age} years of Age`}</p> */}
          <p className={S.headerDescText}>{`Date: ${new Date(
            data?.updatedAt
          ).toLocaleString()}`}</p>
        </div>
      </div>
      <div
        className={S.result}
        style={{ background: getActColor(data?.act, 33) }}
      >
        <div
          className={S.resultScore}
          style={{ color: getActColor(data?.act) }}
        >
          <span>{data?.act}</span>
        </div>
        <div className={S.resultDesc}>
          <p className={S.resultDescTitle}>{data?.actTitle}</p>
          <p
            className={S.resultDescText}
            style={{ color: getActColor(data?.act) }}
          >
            {data?.actSubTitle}
          </p>
        </div>
      </div>
      {/* <div className={S.detail}>
        <ul className={S.detailList}>
          {getActInst(data?.act)?.map((line, key) => (
            <li className={S.detailListItem} key={key}>
              <Icomoon
                className={S.detailListItemIcon}
                icon={"circle"}
                style={{ color: getActColor(data?.act) }}
              />
              <span className={S.detailListItemText}>{line}</span>
            </li>
          ))}
          <li className={S.detailListWarning}>
            <span className={S.detailListWarningText}>
              {
                "This assessment is only for wellness/reference purpose. Always consult a physician if you have trouble breathing or experience other upper respiratory symptoms. Only take medicine according to your doctor's instruction"
              }
            </span>
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default React.memo(ActWidget);

const getActInst = (act) => {
  if (act === null) return [];

  let inst = [];
  if (act <= 20) {
    inst = [
      "Your asthma may not be controlled.",
      "Uncontrolled asthma can seriously harm your health.",
      "Tell your pharmacist now. You should see your doctor immediately.You may need a new or different medication.",
    ];
  } else if (act > 20 && act < 24) {
    inst = [
      "Your asthma may be well controlled.",
      "Continue taking your medication as prescribed.",
      "Your asthma symptoms can change, even if you continue taking your medication. If you have symptoms then see your doctor.",
    ];
  } else {
    inst = [
      "Your asthma is totally controlled.",
      "You have no symptoms. Continue taking your medication as prescribed.",
      "If symptoms worsen then see your doctor.",
    ];
  }
  return inst;
};

export const getActColor = (act, op = 0) => {
  let color = "";
  if (act <= 20) {
    color = `#ff0000`;
  } else if (act > 20 && act < 24) {
    color = `#fbd849`;
  } else {
    color = `#05c46b`;
  }
  return op ? color + op : color;
};
